import JOnlineCode from "./src/JCode/index";

var components = [JOnlineCode];

var install = function install(Vue) {
  var options =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  components.forEach(function(component) {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  version: "1.2.35",
  install: install
};
export { JOnlineCode };
